import { render, staticRenderFns } from "./ItemHeader.vue?vue&type=template&id=0bf75b79&scoped=true&"
import script from "./ItemHeader.vue?vue&type=script&lang=js&"
export * from "./ItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./ItemHeader.vue?vue&type=style&index=0&id=0bf75b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf75b79",
  null
  
)

export default component.exports